<!--电能消耗 usePowerDifference-->
<template>
  <div class="usepowerdifference">
    <div class="con">
      <div class="tree-left">
        <!-- 新的Element多选设备树形控件 -->
        <div style="margin-bottom: 5px;">
          <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        </div>
        <el-scrollbar style="height:calc(100% - 55px);width: 100%;">
          <el-tree class="filter-tree" show-checkbox :data="virtualDeviceList" highlight-current
            :filter-node-method="filterNode" ref="tree" @check='tree_fn' auto-expand-parent :props="defaultProps"
            node-key="no" :default-expanded-keys='checkedData'>
            <template #default="{ node,data }">
              <span class="custom-tree-node">
                <img src="../../../public/static/image/elTree/1.9.png" v-if="data.entityName=='AppClassType'" />
                <img src="../../../public/static/image/elTree/2.1.png" v-else />
                {{ node.label }}
              </span>
            </template>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="right-table">
        <div class="el-loading-mask" v-show="isMask">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
        <datePicker ref="endPicker" :initDate='nowSelectDate' :timeInterval="nowTimeInterval"
          @selectDate="cacheStore.commit('setNowSelectDate', $event), $refs.endPicker.hide()"
          @selectMonth="cacheStore.commit('setNowSelectDate', $event), $refs.endPicker.hide()"
          @selectYear="cacheStore.commit('setNowSelectDate', $event), $refs.endPicker.hide()" :type="datePickerType"
          @selectTimeInterval="selectTimeInterval($event)" :endCanSelect="endCanSelect"></datePicker>
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <span>能源类型：</span>
                <el-select class="selecteds" v-model="targetApptype" placeholder="请选择">
                  <el-option label="水" :value="237"></el-option>
                  <el-option label="电" :value="36"></el-option>
                  <el-option label="气" :value="351"></el-option>
                  <el-option label="汽" :value="352"></el-option>
                </el-select>
              </div>
              <div class="input-small mr-20">
                <el-select v-model="nowTimetype" placeholder="请选择">
                  <el-option label="日" :value="'day'"></el-option>
                  <el-option label="月" :value="'month'"></el-option>
                  <el-option label="年" :value="'year'"></el-option>
                  <el-option label="时间段" :value="'custom'"></el-option>
                </el-select>
              </div>
              <!-- <timeTypeSelection @selectTimetype="nowTimetype = $event" :userDefined="true"></timeTypeSelection> -->
              <div class="input-small ">
                <!-- <span>时间：</span> -->
                <!-- <iconButton icoName="wedoButton/date.png" :buttonText="getDateText(nowSelectDate, nowTimeInterval)"
                  @buttonClick="$refs.endPicker.show()"></iconButton> -->
                <el-date-picker class="picker selecteds" v-model="dateValue" :type="timerType" placeholder="请选择日期"
                  :picker-options="pickerOptions" v-show="nowTimetype != 'custom'"></el-date-picker>
                  
                <el-date-picker class="selecteds" v-model="customTimer" type="daterange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                  v-show="nowTimetype == 'custom'">
                </el-date-picker>
              </div>
              <el-button type="primary" plain @click="search" size="mini" style="margin-left: 15px;">查询</el-button>
              <el-button @click="exportExcel" type="primary" size="mini">导出</el-button>
              <el-button size="mini" @click="heji" plain
                :type="heji_status?'warning':'success'">{{heji_status?'切换':'合计'}}</el-button>
            </div>
          </el-scrollbar>

        </div>
        <vchart style="height: 50%;" ref='vchart'></vchart>
        <!--表格显示数据-->
        <div class="titled">
          <span>数据报表 (单位：kWh)</span>
          <span>总计：<span style="color: red;font-weight: bold;">{{summary}}</span></span>
        </div>
        <div class="mytable" id="printCons">
          <el-table :max-height="heights" :data="nowPage" border style="width: 100%">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="60" align="center" fixed>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="变量名" width="220" align="center" fixed>
              <template slot-scope="scope">
                <span>{{ scope.row[0] }}</span>
              </template>
            </el-table-column>
            <el-table-column v-for="(column,r) in columns" :label="column.name" width="120" align="center"
              v-if="r && r!==columns.length-1">
              <template slot-scope="scope">
                <span>{{ scope.row[r] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="小计" width="120" align="center" fixed="right">
              <template slot-scope="scope">
                <span style="color: #a0a700;font-weight: bold; ">{{ scope.row[columns.length-1] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <downloadTable ref="downloadTable"></downloadTable>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import treeBody from '@/components/module/slotModule/treeBody.vue'
  import datePicker from '@/components/module/universal/datePicker.vue'
  import iconButton from '@/components/module/universal/iconButton.vue'
  import multipleSelection from '@/components/module/selection/multipleSelection.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  import timeTypeSelection from '@/components/module/selection/timeTypeSelection.vue'
  import variableApi from "../../components/api/variableApi";
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import {parseTime} from "@/utils";
  export default {
    components: {
      treeBody,
      datePicker,
      iconButton,
      multipleSelection,
      vchart,
      timeTypeSelection,
      downloadTable
    },
    props: [],
    data () {
      return {
        lasDay: 0,
        isMask: false,//遮罩层
        heji_status: true,
        filterText: "",
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },
        heights: Math.round((document.getElementById('app').clientHeight)*0.32),
        checkedData: [],
        targetApptypeGroups: [
          {
            name: "电",
            no: 36
          },
          {
            name: "水",
            no: 237
          },
          {
            name: "气",
            no: 361
          },
        ],
        nowVirtualDevice: undefined,
        nowTimetype: 'day',
        options: {},
        options2: {},//合计数
        dataObject: {},
        nowIndex: 0,
        pageLen: 5,
        weekList: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
        from2name: {},
        targetApptype: 36,
        endTime: '',
        endCanSelect: new Date(new Date().getTime()+60*60*24),
        radio: 36,
        unit: '',
        summary: '',//合计
        variableTree: [],
        timesList: [
          {
            'name': "日",
            'id': 'day'
          },

          {
            'name': "月",
            'id': 'month'
          },

          {
            'name': "年",
            'id': 'year'
          },
          {
            'name': "时间段",
            'id': 'custom'
          },
        ],
        dateValue: new Date(),
        timerType: 'date',
        customTimer: []
      }
    },
    mounted () {
      var date=new Date()
      var str=date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()
      var today=new Date(str)
      this.customTimer=[today,new Date()]
      debugPage=this
      //初始化图表
      this.options=this.$refs.vchart.getDefaultOptions()
      this.options.toolbox={
        show: true,
        showTitle: false, // 隐藏默认文字，否则两者位置会重叠
        top: '-5',
        right: "50",
        feature: {
          magicType: {
            type: ['line','bar','stack','tiled'],title: {
              line: '切换为折线图',
              bar: '切换为柱状图',
              stack: '切换为堆叠',
              tiled: '切换为平铺',
            }
          },

          saveAsImage: {
            show: true,
            title: '下载图片'
          },
          // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
        },

      },
        this.options.backgroundColor='#FFFFFF'
      this.options.tooltip.formatter=(params,ticket,callback) => {
        if(params[0].data==undefined) {
          return ""
        }
        var h=params[0].data[0]
        var label=h+"</br>"
        params.forEach(item => {
          var values;
          if(isnull(item.data[1])) {
            values="无采集数据";
          } else {
            values=cutDigital(item.data[1]);
          }
          label+=item.seriesName+" : "+values+" (kW·h)</br>"
        })
        return label;
      }
      this.options.yAxis={
        splitLine: {
          show: true
        }
      }
      switch(this.targetApptype) {
        case 36:
          this.options.title.text="用电量(KW·h)"
          break
        case 237:
          this.options.title.text="用水量(t)"
          break
        case 361:
          this.options.title.text="用气量(m³)"
          break
        case 362:
          this.options.title.text="用汽量"
          break
      }
      this.setDataed()
      this.digui(this.virtualDeviceList)
      this.search()
    },

    computed: {
      nowTimeInterval () {
        return this.cacheStore.getters.getNowTimeInterval
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      cacheStore () {
        return this.$store.cacheStore
      },
      virtualDeviceList () {
        if(isempty(this.nowUnit)) {
          return []
        }
        var arr=[deviceList(this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(this.targetApptype,this.nowUnit.id))]
        return arr
      },
      datePickerType () {
        switch(this.nowTimetype) {
          case 'day':
          case 'week':
            return 'day'
          case 'month':
          case 'quarter':
            return 'month'
          case 'year':
            return 'year'
          case 'custom':
            return 'custom'
        }
      },
      apptypeGroups () {
        //所有已选中的设备所具有的变量类型组
        var list=[]
        var apptypeGroupIds=[]
        this.variableTree.forEach(apptypeGroup => {
          if(!apptypeGroupIds.includes(apptypeGroup.id)) {
            apptypeGroupIds.push(apptypeGroup.id)
            list.push(apptypeGroup)
          }
        })
        //排序
        return list.sort((a,b) => {
          return a.serialnum-b.serialnum
        })
      },
      nowSelectDate () {
        return this.cacheStore.getters.getNowSelectDate
      },

      columns () {
        var list=[{
          name: '变量名',
          weight: 3,
        }]
        switch(this.nowTimetype) {
          case 'day':
            //取出每个整点值
            for(var i=0;i<24;i++) {
              var label=(i<10? "0":'')+(i)+":00-"+(i+1<10? "0":'')+(i+1)+":00"
              list.push({
                name: label //i + ' - ' + (i + 1)
              })
            }
            break
          case 'week':
            for(var i=0;i<7;i++) {
              list.push({
                name: this.weekList[i]
              })
            }
            break
          case 'month':
            let lasDay=new Date(this.dateValue.format("yyyy"),this.dateValue.format("MM"),0).getDate();
            this.lasDay=lasDay;
            for(var i=1;i<=lasDay;i++) {
              list.push({
                name: i+"日"
              })
            }
            break
          case 'quarter':
            for(var i=0;i<3;i++) {
              list.push({
                name: this.getQuarterList(this.nowSelectDate)[i]
              })
            }
            break
          case 'year':
            for(var i=1;i<=12;i++) {
              list.push({
                name: i+"月"
              })
            }
            break
          case 'custom':
            var time=this.customTimer[1].getTime()-this.customTimer[0].getTime()
            var dayNum=Math.floor((time)/(24*60*60*1000))+1
            var value=[]
            if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
              value=undefined
            }
            if(this.customTimer[1].getMonth()!=this.customTimer[0].getMonth()) {
              var lastmonthNum=dayNum-this.customTimer[1].getDate()
              for(var i=0;i<lastmonthNum;i++) {
                list.push({
                  name: this.customTimer[0].getMonth()+1+'月'+(this.customTimer[0].getDate()+i)+'日'
                })
              }
              for(var j=0;j<this.customTimer[1].getDate();j++) {
                list.push({
                  name: this.customTimer[1].getMonth()+1+'月'+(j+1)+'日'
                })
              }
            } else {
              if(this.customTimer[0].getDate()==this.customTimer[1].getDate()) {
                list.push({
                  name: this.customTimer[1].getMonth()+1+'月'+(this.customTimer[1].getDate())+'日'
                })
              } else {
                for(var i2=0;i2<dayNum;i2++) { //l.length
                  list.push({
                    name: this.customTimer[0].getMonth()+1+'月'+(this.customTimer[0].getDate()+i2)+'日'
                  })
                }
              }

            }
            break
        }
        list.push({name: '小计'})
        return list
      },
      nowVariableNames () {
        //当前应该显示的变量
        var variableList=[]
        for(var i=0,len=this.variableTree.length;i<len;i++) {
          this.variableTree[i].next.forEach(v => {
            if(v.typeNo==this.targetApptype) {
              this.unit=this.variableTree[i].unit
              this.from2name[v.fromName]=v.name
              variableList.push(v.fromName)
            }
          })
        }
        return variableList
      },

      nowVariableNamesS () {
        //当前应该显示的变量
        var variableList=[]
        this.nowDevice.forEach(item => {
          this.nowVirtualDevice=item
          for(var i=0,len=this.variableTree.length;i<len;i++) {
            this.variableTree[i].next.forEach(v => {
              if(v.typeNo==this.targetApptype) {
                this.from2name[v.fromName]=v.name
                variableList.push(v.fromName)
              }
            })
          }
        })

        return variableList
      },
      showDataList () {
        //用于渲染的合并后的数组
        if(isempty(this.dataObject)) {
          return []
        }
        //取出数据中的有效数据组织为数组
        var list=[]
        var keys=Object.keys(this.dataObject)
        for(var i=0,len=keys.length;i<len;i++) {
          var key=keys[i];
          var dataList=[]
          if(this.dataObject[key] instanceof Array) {
            dataList=this.dataObject[key].map(i => {
              if(isNaN(parseFloat((i)))||isnull(parseFloat((i)))) {
                return undefined
              } else {
                return i
              }
            })
          }

          // if(this.nowTimetype == "month") {
          // 	let lasDay = new Date(this.nowSelectDate.format("yyyy"), this.nowSelectDate.format("MM"), 0).getDate()
          // 	if(lasDay == 30) {
          // 		dataList.shift()
          // 	}
          // }
          //var vList = [key.subByFirstChar('.')]
          var vList=[key]
          vList.addAll(dataList)
          list.push(vList)
        }
        return list.sort()
      },
      chartDataList () {
        //图表使用的数据
        var list=[]
        for(var i=0,len=this.showDataList.length;i<len;i++) {
          var l=this.showDataList[i]
          var l2=[this.nowVariableNames[i]] //变量名称
          switch(this.nowTimetype) {
            case 'day':
              //取出每个整点值
              for(var i2=1,len2=25;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                var label=(i2-1<10? "0":'')+(i2-1)+":00-"+(i2<10? "0":'')+i2+":00"
                l2.push([label,value])
              }
              break
            case 'week':
              for(var i2=1,len2=8;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([this.weekList[i2-1],value])
              }
              break
            case 'month':
              let lasDay=new Date(this.nowSelectDate.format("yyyy"),this.nowSelectDate.format("MM"),0).getDate()+1
              //判断月份是否有31
              for(var i2=1,len2=lasDay;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([(i2)+'日',value])
              }
              break
            case 'quarter':
              for(var i2=1,len2=4;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([this.getQuarterList(this.nowSelectDate)[i2-1],value])
              }
              break
            case 'year':
              for(var i2=1,len2=13;i2<len2;i2++) { //l.length
                var value=l[i2]
                if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                  value=undefined
                }
                l2.push([(i2)+'月',value])
              }
              break
            case 'custom':
              var time=this.customTimer[1].getTime()-this.customTimer[0].getTime()
              var dayNum=Math.floor((time)/(24*60*60*1000))+1
              var value=[]
              if(isNaN(parseFloat(value))||isnull(parseFloat(value))) {
                value=undefined
              }
              if(this.customTimer[1].getMonth()!=this.customTimer[0].getMonth()) {
                var lastmonthNum=dayNum-this.customTimer[1].getDate()
                for(var i=0;i<lastmonthNum;i++) {
                  l2.push([this.customTimer[0].getMonth()+1+'月'+(this.customTimer[0].getDate()+i)+'日',l[i+1]])
                }
                for(var j=0;j<this.customTimer[1].getDate();j++) {
                  l2.push([this.customTimer[1].getMonth()+1+'月'+(j+1)+'日',l[j+lastmonthNum+1]])
                }
              } else {
                if(this.customTimer[0].getDate()==this.customTimer[1].getDate()) {
                  l2.push([this.customTimer[1].getMonth()+1+'月'+(this.customTimer[1].getDate())+'日',l[1]])
                } else {
                  for(var i2=0;i2<dayNum;i2++) { //l.length
                    l2.push([this.customTimer[0].getMonth()+1+'月'+(this.customTimer[0].getDate()+i2)+'日',l[i2+1]])
                  }
                }
              }
              l2.push([this.customTimer[0].formatByTime(),l[1]])
              break
          }
          list.push(l2)
        }
        return list
      },
      nowPage () {
        return this.showDataList

        //按照页码来返回当前应该显示的列表
        // return this.showDataList.filter((item,index) => {
        //   return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        // })
      },
      getDateText () {
        return (date,timeInterval) => {
          switch(this.nowTimetype) {
            case 'day':
              return date.formatByDate('-')
            case 'week':
              return date.formatByDate('-')
            case 'month':
              return date.formatByMonth('-')
            case 'quarter':
              return date.formatByMonth('-')
            case 'year':
              return date.getFullYear()+''
            case 'custom':
              return timeInterval.startDate.formatByDate('/')+"—"+timeInterval.endDate.formatByDate('/')
          }
        }
      },
    },
    watch: {
      nowVirtualDevice (nv,ov) {
        // this.search();
      },
      nowVariableNames (nv,ov) {
        //this.search()
      },
      chartDataList (nv,ov) {
        //重新渲染
        // console.log(nv);
        this.reloadChart(nv)
      },
      nowTimetype (nv,ov) {
        this.search()
        if(nv=='day') {
          this.timerType='date'
        } else {
          this.timerType=nv
        }

      },
      nowSelectDate (nv,ov) {
        //this.search()
      },
      nowTimeInterval (nv,ov) {
        //this.search()
      },
      targetApptype (nv,ov) {
        //切换能源类型刷新页面
        this.dataObject={}
        switch(this.targetApptype) {
          case 36:
            this.options.title.text="用电量(KW·h)"
            break
          case 237:
            this.options.title.text="用水量(t)"
            break
          case 361:
            this.options.title.text="用气量(m³)"
            break
          case 362:
            this.options.title.text="用汽量"
            break
        }
        this.setDataed()
      }
    },
    methods: {
      heji () {
        this.heji_status=!this.heji_status;

        this.setDataed()
      },
      setDataed () {
        if(this.nowTimetype=='month') {
          console.log(this.lasDay,'lasDaylasDaylasDay');

          this.options.series.map(v => {
            v.data.length=this.lasDay
          })
          console.log(this.options.series,'daaa');
        }
        if(this.heji_status) {
          this.options2=JSON.parse(JSON.stringify(this.options))
          var d=this.options2.series;
          var dataed=[];

          d.map((v,i) => {
            if(!i) {
              v.data.map((a,ii) => {
                if(a[1]) {
                  a[1]=Number(a[1]);
                }
              })
              dataed=v;
            } else {
              v.data.map((a,ii) => {
                if(a[1]) {
                  console.log(Number(a[1]));
                  dataed.data[ii][1]+=Number(a[1])
                }
              })
            }
          })
          if(dataed.length==0) {
            return
          }
          dataed.data.map(v => {
            if(v[1]) {
              v[1]=v[1].toFixed(2);
            }
          })

          dataed.name='合计';
          this.options2.series=[dataed];
          this.options2.legend.data=[{
            icon: "roundRect",
            name: '合计'
          }]

          this.$refs.vchart.setData(this.options2,true)
        } else {
          this.$refs.vchart.setData(this.options,true)
        }

      },
      digui (data) {
        var device=[]
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.hasOwnProperty('children')&&row.children.length!=0) {
                getStr(row.children)
              } else {
                device.push(row)

              }
            })
          }
          getStr(data)
        }
        recursiveFunction()
        this.checkedData=[device[0].no]
        this.$nextTick(() => {
          //默认选中
          this.$refs['tree'].setCheckedNodes([device[0]]);
          this.nowVirtualDevice=[device[0]]
          this.search()
        })


      },
      // 树形筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.name.indexOf(value)!==-1;
      },
      tree_fn (v,val) {
        var data=[]
        val.checkedNodes.forEach(item => {
          if(item.entityName=='VirtualDevicePojo') {
            data.push(item)
          }
        })
        this.nowVirtualDevice=data

      },
      select_fn () {},
      // demo(e) {
      // 	let a = []
      // 	e.map(v => {
      // 		if (v.pkid == null) {
      // 			a.push(v)
      // 		}
      // 	})
      // 	this.nowVirtualDevice = a
      // },
      selectTimeInterval (ev) {
        this.cacheStore.commit('setNowTimeInterval',ev)
        this.$refs.endPicker.hide()
      },
      search () {
        //先查询设备信息  再查数据
        if(isempty(this.nowVirtualDevice)) {
          return;
        }

        var deviceNoList=[]
        for(var i=0;i<this.nowVirtualDevice.length;i++) {
          if(!isempty(this.nowVirtualDevice[i].children)) {
            continue
          } else {
            deviceNoList.push(this.nowVirtualDevice[i].no)
          }
        }
        this.$refs.vchart.showLoading();
        this.$api.variableApi.getVariableTree(deviceNoList.join(","),respon => {
          this.variableTree=respon

          if(isempty(this.nowVariableNames)) {
            return
          }
          this.dataObject={}
          if(this.nowTimetype=='custom') {
            // if(this.nowTimeInterval.endDate.getTime()-this.nowTimeInterval.startDate.getTime()>60*60*24*30*1000) {
            //   this.$dialogMethod.showMessage("时间跨度不能大于一个月!")
            //   return
            // }

            // this.$api.historyApi.getHistoryDifferenceRanking(this.nowVariableNames.join(','),this.nowTimetype,this.nowTimeInterval.startDate.getTime(),this.nowTimeInterval.endDate.getTime(),
            //   respon => {
            //     this.isMask = false
            //     this.summary=respon['summary'];
            //     delete respon['summary']
            //     this.dataObject=respon;
            //   })
            if(this.customTimer[0].getTime()-this.customTimer[1].getTime()>60*60*24*30*1000) {
              this.$dialogMethod.showMessage("时间跨度不能大于一个月!")
              return
            }
            this.$api.historyApi.getHistoryDifferenceRanking(this.nowVariableNames.join(','),this.nowTimetype,this.customTimer[0].getTime(),this.customTimer[1].getTime(),
              respon => {
                this.$refs.vchart.hideLoading();
                this.summary=respon['summary'];
                delete respon['summary']
                this.dataObject=respon;
              })
          } else {
            // this.$api.historyApi.getHistoryDifferenceRanking(this.nowVariableNames.join(','),this.nowTimetype,this.nowSelectDate
            //   .getTime(),'',
            //   respon => {
            //       this.isMask = false
            //     this.summary=respon['summary'];
            //     delete respon['summary']
            //     this.dataObject=respon
            //   })
            this.$api.historyApi.getHistoryDifferenceRanking(this.nowVariableNames.join(','),this.nowTimetype,this.dateValue
              .getTime(),'',
              respon => {
                this.$refs.vchart.hideLoading();
                this.summary=respon['summary'];
                delete respon['summary']
                this.dataObject=respon
              })
          }
        })
      },
      reloadChart (list) {
        var selected={}
        var legend=[]
        var seriesList=[]
        for(var i=0,len=list.length;i<len;i++) {
          let item=list[i]
          var name=list[i].shift()
          seriesList.push({
            name: name,
            type: 'bar',
            smooth: true,
            symbol: 'emptyCircle',
            sampling: 'average',
            data: item
          })
          selected[name]=i<12? true:false
          legend.push({
            name: name,
            icon: 'roundRect'
          })
        }

        if(this.nowTimetype=='custom'&&seriesList[0]) {
          seriesList[0].data=seriesList[0].data.slice(0,seriesList[0].data.length-1);
        }
        this.options.series=seriesList
        this.options.legend.data=legend
        this.options.legend.selected=selected

        this.options.tooltip.formatter=(params,ticket,callback) => {
          if(params[0].data==undefined) {
            return ""
          }
          var h=params[0].data[0]
          var label=h+"</br>"
          params.forEach(item => {
            var values;
            if(isnull(item.data[1])) {
              values="无采集数据";
            } else {
              values=cutDigital(item.data[1]);
            }
            label+=item.seriesName+" : "+values+" ("+this.unit+")</br>"
          })
          return label;
        }
        // switch (this.targetApptype) {
        // 	case 36:
        // 		//this.options.title.text = this.nowVirtualDevice.name + "-用电量"
        // 		this.options.title.text = "用电量"
        // 		break
        // 	case 237:
        // 		this.options.title.text = "用水量"
        // 		break
        // 	case 361:
        // 		this.options.title.text = "用气量"
        // 		break
        // 	case 362:
        // 		this.options.title.text = "用汽量"
        // 		break
        // } 
        this.setDataed()
      },
      getQuarterList (date) {
        switch(date.getMonth()/3|0) {
          case 0:
            return ['一月','二月','三月']
          case 1:
            return ['四月','五月','六月']
          case 2:
            return ['七月','八月','九月']
          case 3:
            return ['十月','十一月','十二月']
        }
      },
      exportExcel () {
        this.nowDevice=[this.nowVirtualDevice]
        let list=this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(this.targetApptype,this.nowUnit.id)
        var title='电能消耗'

        switch(this.nowTimetype) {
          case "custom":
            title=this.nowTimeInterval.startDate.format("yyyy年MM月dd日")+"至"+this.nowTimeInterval.endDate.format("yyyy年MM月dd日")+"电能消耗"
            break;
          case "day":
            title=this.nowSelectDate.format("yyyy年MM月dd日")+"电能消耗"
            break;
          case "week":
            let getDate=getMonthWeek(this.nowSelectDate.format("yyyy"),this.nowSelectDate.format("MM"),this.nowSelectDate.format("dd"));
            title=getDate.getYear+"年"+getDate.getMonth+"月第"+getDate.getWeek+"周"+"电能消耗"
            break;
          case "month":
            title=this.nowSelectDate.format("yyyy年MM月")+"电能消耗"
            break;
          case "quarter":
            title="第"+this.nowSelectDate.format("q")+"季电能消耗"
            break;
          case "year":
            title=this.nowSelectDate.format("yyyy")+"年电能消耗"
            break;
          default:
            title="电能消耗"
        }

        const tHeader=[title];
        this.$refs.downloadTable.export2Excel(tHeader,this.nowPage,title,'#printCons')

        // if(this.nowTimetype!='custom') {

        //   this.$api.reportApi.exportHistoryDifferenceRanking(title,this.nowVariableNamesS.join(','),this.nowSelectDate.getTime(),this.nowTimetype,
        //     respon => {
        //       saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
        //     })
        // } else {
        //   //时间段的导出
        //   this.$api.reportApi.exportHistoryDifferenceRankingCustom(title,this.nowVariableNamesS.join(','),this.nowTimeInterval.startDate.getTime(),this.nowTimeInterval.endDate.getTime(),this.nowTimetype,
        //     respon => {
        //       saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
        //     })
        // }

      },
      exportAllExcel () {
        this.$dialogMethod.showLoading("正在生成报告。。。")
        if(this.nowTimetype!='custom') {
          this.$api.reportApi.exportAllPowerDifferenceRanking(this.nowSelectDate.getTime(),respon => {
            if(!respon.includes('%2F')) {
              this.$dialogMethod.showMessage(respon)
              return
            }
            saveAs(DWSystemSetting.downloadUrl+'/'+respon,respon.substring(respon.lastIndexOf('%2F')+3))
            this.$dialogMethod.closeLoading()
          })
        } else {
          this.$api.reportApi.exportAllPowerDifferenceRankingCustom(this.nowTimeInterval.startDate.getTime(),this.nowTimeInterval.endDate.getTime(),this.nowTimetype,respon => {
            if(!respon.includes('%2F')) {
              this.$dialogMethod.showMessage(respon)
              return
            }
            saveAs(DWSystemSetting.downloadUrl+'/'+respon,respon.substring(respon.lastIndexOf('%2F')+3))
            this.$dialogMethod.closeLoading()
          })
        }
      }
    }
  }
</script>
<style>
  .selecteds {
    width: 100px;
    overflow: hidden;
  }

  .selecteds .el-input {
    width: 100px;
  }

  .selecteds .el-input input {
    width: 100px;
  }
</style>

<style scoped lang="scss">
  .titled {
    display: flex;
    font-weight: bold;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  /deep/.el-loading-mask {
    background-color: rgba(255, 255, 255, 1) !important;
  }

  .titled span {
    font-size: .16rem;
  }

  .search-input-btn {
    height: 43px;
  }

  .usepowerdifference {
    .con {
      width: 100%;
      height: 100%;
      display: flex;

      .tree-left {
        width: 300rem;
        height: 100%;
        background-color: #fff;
        margin-right: 8px;
        padding: 12px;
        box-sizing: border-box;
      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        background-color: #fff;
        padding: 2px 20px 12px 20px;
        box-sizing: border-box;
        position: relative;
      }

      /deep/.thable {
        background-color: #368ed9;
      }

      /deep/.infolist-table-body th,
      .infolist-table-body td {
        color: #fff;
      }
    }
  }
</style>